import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { store, persistor } from "./store";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import moment from "moment";

const queryClient = new QueryClient();
queryClient.setDefaultOptions({
    queries: {
        staleTime: moment({ hour: 1, minute: 0, second: 0 }).milliseconds()
    }
});

ReactDOM.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <App></App>
                </PersistGate>
            </Provider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById("root")
);
